import { type JSX, useEffect } from 'react';
import type { IGeneralPractitioner } from '@common/interfaces/generalPractitioner';
import { ProcessActivityCareProviderSelector } from '@frontend/components/pages/episodeCategory/customControls/ProcessActivityCareProviderSelector';
import { useEditFormSectionInputFieldContext } from '@frontend/formEngine/editForm/useEditFormContext';
import { useProcessActivityEditContext } from '@frontend/utils';
import { usePatientEpisodeCategoryContext } from '@frontend/utils/hooks/usePatientEpisodeCategoryContext';

export function GeneralPractitionerSelector(): JSX.Element | null {
    const { patient } = usePatientEpisodeCategoryContext();
    const { data, errors } = useProcessActivityEditContext<{ generalPractitioner: IGeneralPractitioner }>();
    const { isRequired, onChange } = useEditFormSectionInputFieldContext();

    useEffect(() => {
        if (
            !data.generalPractitioner.organizationId &&
            !data.generalPractitioner.practitionerId &&
            patient.careProviderPractitionerId &&
            patient.careProviderOrganizationId
        ) {
            onChange({
                organizationId: patient.careProviderOrganizationId,
                practitionerId: patient.careProviderPractitionerId,
            });
        }
    }, [patient.careProviderPractitionerId, patient.careProviderOrganizationId]);

    return (
        <ProcessActivityCareProviderSelector
            error={errors.get('generalPractitioner.organizationId') ?? errors.get('generalPractitioner.practitionerId')}
            generalPractitioner={data.generalPractitioner}
            isRequired={isRequired}
            itemsPerPage={5}
            onChange={(organizationId, practitionerId) => onChange({ organizationId, practitionerId })}
            patient={patient}
        />
    );
}
